import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { GridLayout } from '@hh.ru/magritte-ui';

import ThemeContainer, { ThemeContainerBackground, ThemeContainerVariant } from 'src/components/ThemeContainer';
import SectionAdvantages from 'src/pages/CertLanding/components/SectionAdvantages';
import SectionSkills from 'src/pages/CertLanding/components/SectionSkills';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.page-cert-landing.section.skills.title',
};

const SectionMain: TranslatedComponent = ({ trls }) => {
    return (
        <ThemeContainer variant={ThemeContainerVariant.Night} background={ThemeContainerBackground.Transparent}>
            <section className={styles.wrapper}>
                <GridLayout>
                    <div className={styles.container}>
                        <h1 className={styles.title}>{trls[TrlKeys.title]}</h1>
                        <SectionSkills />
                        <SectionAdvantages />
                    </div>
                </GridLayout>
            </section>
        </ThemeContainer>
    );
};

export default translation(SectionMain);
